// extracted by mini-css-extract-plugin
export var container = "_pf-0";
export var dotAnimation = "_pf-2";
export var dotsLoading = "_pf-1";